import {AbstractEvent} from "@/modules/base/events";

export class BeforeCreateGameEvent extends AbstractEvent {
}
